<template>
  <div>
    <pie-chart :legendData="legendData" :series="series" :type="'gender'" />
    <p class="charttips">说明：图示为所选统计区间各性别赔付金额</p>
  </div>
</template>
<script>
import PieChart from '@/components/layouts/PieChart';
import { formatEmun } from '@/utils/utils';
export default {
  components: {
    PieChart,
  },
  props: {
    genderArr: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    legendData() {
      let arr = [];
      this.genderArr.map((item) => {
        arr.push(this.genderFormate(item.insuredSex));
      });
      return arr;
    },
    series() {
      // [
      //   {
      //     name: 'WEEKLY WRITE ARTICLES',
      //     type: 'pie',
      //     radius: 95,
      //     center: ['50%', '38%'],
      //     data: [
      //       { value: 320, name: 'Industries' },
      //       { value: 240, name: 'Technology' },

      //     ],
      //     animationEasing: 'cubicInOut',
      //     animationDuration: 2600
      //   }
      // ]

      let data = [];

      this.genderArr.map((item) => {
        data.push(
          // {value:item.insuredNum,name:this.genderFormate(item.insuredSex)}
          {
            name:this.genderFormate(item.insuredSex),
            value: item.totalAmount,
            datas: [item.insuredNum, item.totalAmount],
            itemStyle: item.insuredSex==1?{ color: '#5788BB' }:{ color: '#F7B334' }
          }
        );
      });
      return [
        {
          name: '',
          type: 'pie',
          radius: 95,
          center: ['50%', '38%'],
          data: data,
          animationEasing: 'cubicInOut',
          animationDuration: 2600,
        },
      ];
    },
  },
  methods: {
    genderFormate(data) {
      return formatEmun('genderType', data);
    },
  },
};
</script>